import { h, Host } from "@stencil/core";
import { logger } from "../../utils/console";
import { limitSlotElements } from "../../utils/limitSlotElements";
/**
 * UxTableNeo - Experimental table component
 * @slot footer - The footer of the table, limited to ux-table-footer-neo
 * @slot - The rows of the tablem limited to <ux-table-head> and <ux-table-body>
 * @slot caption - The caption of the table, limited to ux-table-caption-neo
 */
export class TableNEo {
    constructor() {
        this.summary = undefined;
        this.loading = undefined;
        this.rowCount = undefined;
        this.headCellCount = undefined;
        this.customWidths = [];
    }
    host;
    rowCountChangeHandler(event) {
        this.rowCount = event.detail;
        this.host.style.setProperty("--ux-row-count", this.rowCount.toString());
        event.stopPropagation();
    }
    headCellCountChange(event) {
        this.headCellCount = event.detail;
        this.host.style.setProperty("--ux-head-cell-count", this.headCellCount.toString());
        event.stopPropagation();
    }
    widthChangeHandler(event) {
        this.customWidths = [];
        for (let index = 0; index < this.headCellCount; index++) {
            if (event.detail.colIndex === index) {
                this.customWidths.push(`${event.detail.width}px`);
            }
            else {
                this.customWidths.push("1fr");
            }
        }
        this.host.style.setProperty("--ux-table-col-template", this.customWidths.join(" "));
    }
    componentWillRender() {
        if (!this.summary) {
            logger.warn("No summary provided for table");
        }
    }
    componentDidLoad() {
        limitSlotElements(this.host, {
            allowed: {
                caption: ["ux-table-caption-neo"],
                footer: ["ux-table-footer-neo"]
            }
        });
    }
    setLoadingState(enabled = this.loading) {
        const rowsHead = Array.from(this.host.querySelectorAll("ux-table-header-neo ux-table-row-neo"));
        const rows = Array.from(this.host.querySelectorAll("ux-table-body-neo ux-table-row-neo"));
        for (const row of [...rowsHead, ...rows]) {
            row.loading = enabled;
        }
    }
    render() {
        return (h(Host, { key: '03fd9583f6a40306a22b1dac7ec118dde36fd967', role: "table", "aria-rowcount": this.rowCount }, h("slot", { key: '586ebeacebbd99b4c5deb7c655f0a2ed825d4352', name: "caption" }), h("slot", { key: '7195bb576fa81c4b2685926b8db13947041c633e' }), h("slot", { key: '9295ca845f957823edf8e6bc9012f531e5106ed9', name: "footer" })));
    }
    static get is() { return "ux-table-neo"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["table-neo.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["table-neo.css"]
        };
    }
    static get properties() {
        return {
            "summary": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The summary of the table"
                },
                "attribute": "summary",
                "reflect": true
            },
            "loading": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set table to loading state. All child rows & cells will be loading."
                },
                "attribute": "loading",
                "reflect": true
            }
        };
    }
    static get states() {
        return {
            "rowCount": {},
            "headCellCount": {},
            "customWidths": {}
        };
    }
    static get elementRef() { return "host"; }
    static get watchers() {
        return [{
                "propName": "loading",
                "methodName": "setLoadingState"
            }];
    }
    static get listeners() {
        return [{
                "name": "rowCountChange",
                "method": "rowCountChangeHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "headCellCountChange",
                "method": "headCellCountChange",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "widthChange",
                "method": "widthChangeHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=table-neo.js.map
